import { useApiQuery } from '@portals-platform/api-client';
import { useMemo } from 'react';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CountryResponse } from '../api/responses.js';
import { toCountryOptions } from '../mappers/mappers.js';
import type { CountryOption } from '../models.js';
import { queryKeys } from '../query-keys.js';

export function useCountryOptions(): CountryOption[] {
  const { data } = useApiQuery<CountryResponse[]>([...queryKeys.countries()], ENDPOINTS.countries);

  return useMemo(() => toCountryOptions(data), [data]);
}
